import { SiteGatewayZonePricingPlan } from 'src/features/pricing/sites/utils/types';
import { VISITOR_CATEGORY_TYPE } from 'src/features/zone/utils/types';
import { LOCALE } from 'src/providers/types';
import { Translation } from 'src/types';

export enum REQUIRED_IDENTIFIER_TYPES {
    LICENSE_PLATE = 'license_plate',
    TICKET = 'ticket',
    ACCESS_KEY = 'access_key',
}

export type Gateway = {
    id: string;
    translations: {
        id: string;
        created_at: string;
        modified_at: string;
        language: LOCALE;
        name: string;
        description: string;
    }[];
    created_at: string;
    modified_at: string;
    required_identifier_types: REQUIRED_IDENTIFIER_TYPES[];
    entry_zone: {
        id: string;
        translations: Translation[];
    };
    exit_zone: {
        id: string;
        translations: Translation[];
    };
    allow_unknown_main_identifier: boolean;
    require_all_identifier: boolean;
    visitor_categories?: VISITOR_CATEGORY_TYPE[];
};

export interface GatewayPricingPlan extends SiteGatewayZonePricingPlan {
    gateway?: string;
    gateway_translations?: {
        language: string;
        name: string;
    }[];
}
